<template>
    <div>
        <div class='d-flex justify-content-between neue mbp-16'>
            <div v-if="this.title" class="fsp20 lh28 neue">
                {{ this.title }}
            </div>
            <div v-else-if="!this.currKey" class="fsp20 lh28 neue">
                {{ this.currDirection == 'curr_give' ? $t('views.P2P.CheckCurrP2POffers.2') : $t('views.P2P.CheckCurrP2POffers.3') }} 
                {{ $t('views.P2P.CheckCurrP2POffers.4') }}
            </div>
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="neue-roman" :class="{ 'p24 bg-white rounded12': !isMobile }">
            <div class="input-search-wrapper" :class="{ 'mb16': isMobile, 'mbp-24': !isMobile }">
                <span class="d-flex justify-content-center align-items-center">
                    <Icon name="search-grey" class="c16 mr8" :active="false" />
                </span>
                <input class="input-search flex-grow-1 pr-1" ref="input_search" type="text" @input="inputSearchHandler" tabindex="-1" placeholder="Search..."/>
                <span @click.stop="this.clearSearchInput" class="pointer">
                    <Icon v-if="this.textInSearch" name="clear-search" class="pe-none c16 d-flex justify-content-center align-items-center" />
                </span>
            </div>
            <div class="curr-container">
                <div v-if="!this.currKey" class="btn-group w-100 mb16" role="group" aria-label="Basic outlined example">
                    <CustomSelectButton
                        class="w-100"
                        :equalWidth="true"
                        :options="[
                            {
                                value: 1,
                                label: this.$store.state.resize.w > 768 ? $t('views.P2P.CheckCurrP2POffers.8') : $t('views.P2P.CheckCurrP2POffers.13')
                            },
                            {
                                value: 2,
                                label: this.$store.state.resize.w > 768 ? $t('views.P2P.CheckCurrP2POffers.10') : $t('views.P2P.CheckCurrP2POffers.14')
                            }
                        ]"
                        v-model="this.of_stage"
                        @update:modelValue="typeCurrChange"
                    />
                </div>
                <div class="d-flex justify-content-between curr-wrapper">
                    <div 
                        class="internal-curr col-12" 
                        :class="this.blockedCurrType === 'internal' ? 'disabled-curr-list' : ''"
                        v-if="this.of_stage == 1 && this.currKey != 'only_external'"
                    >
                        <div v-if="this.filterCurrListInternal.length > 0" class="d-flex flex-wrap gap16">
                            <div
                                v-for="curr in this.filterCurrListInternal"
                                class="d-flex align-items-center p16 curr-item gap8"
                                :class="this.addActiveClass(this.currKey, this.currDirection, curr.code)" 
                                :key="curr.code"
                                @click="this.choiseCurr(curr.code, curr.full_name, 'internal', this.currDirection)"
                            >   
                                <span v-if="curr.logo">
                                    <img :src="curr.logo" alt="" class="curr-logo">
                                </span>
                                <span v-else>
                                    <Icon name="default-curr" size="c40" />
                                </span> 
                                <span class="d-flex flex-column flex-grow-1">
                                    <span class="fsp14 lh20 neue mbp-4">{{ curr.full_name }}</span>
                                    <span class="fsp12 lh16 primary-grey">{{ curr.small_name }}</span>
                                </span>
                                <div 
                                    v-if="this.addActiveClass(this.currKey, this.currDirection, curr.code) === 'curr-item-selected'"
                                    @click.stop="this.removeCurr(this.currDirection)"
                                >
                                <Icon name="close" :color="{ 0: '#122157'}" class="c16" />
                                </div> 
                            </div>
                        </div>
                        <div v-else class="d-flex col-12">
                            <span class="primary-grey">{{ $t('views.P2P.CheckCurrP2POffers.9') }}</span>
                        </div>
                    </div>
                    <div 
                        class="external-curr col-12" 
                        :class="this.blockedCurrType === 'external' ? 'disabled-curr-list' : ''"
                        v-if="this.of_stage == 2 || this.currKey == 'only_external'"
                    >
                        <div v-if="this.filterCurrListExternal.length > 0" class="d-flex flex-wrap gap16">
                            <div
                                v-for="currExt in this.filterCurrListExternal"
                                class="d-flex align-items-center p16 curr-item gap8"
                                :class="this.addActiveClass(this.currKey, this.currDirection, currExt.code)"
                                :key="currExt.code"
                                @click="this.choiseCurr(currExt.code, currExt.name, 'external', this.currDirection)"
                            >
                                <span class="d-flex flex-column flex-grow-1">
                                    <span class="fsp14 lh20 neue mbp-4">{{ currExt.name }}</span>
                                    <span class="fsp12 lh16 primary-grey">
                                        {{ currExt.curr_text ? currExt.curr_text : currExt.unit }}
                                    </span>
                                </span>
                                <div 
                                    v-if="this.addActiveClass(this.currKey, this.currDirection, currExt.code) === 'curr-item-selected'"
                                    @click.stop="this.removeCurr(this.currDirection)"
                                >
                                <Icon name="close" :color="{ 0: '#122157'}" class="c16" />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <span class="primary-grey">{{ $t('views.P2P.CheckCurrP2POffers.9') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Button from '@/components/service/Button';
    import Icon from '@/components/icons/Icon';
    import CustomSelectButton from '@/components/service/CustomSelectButton';
    export default {
        components: {
            Button,
            Icon,
            CustomSelectButton
        },
        props: {
            close: [Function],
        },
        data () {
            return {
                content: this.$store.state.modal.content,
                currKey: this.$store.state.modal.content.currKey,
                title: this.$store.state.modal.content.title,
                fieldId: this.$store.state.modal.content.fieldId,
                currDirection: this.$store.state.modal.content.currencyData.currDirection,
                selectedCurrency: this.$store.state.modal.content.selectedCurrency,
                filterCurrListInternal: [],
                filterCurrListExternal: [],
                internalKeys: ['full_name', 'small_name'],
                externalKeys: ['name', 'curr_text', 'unit'],
                of_stage: 1,
                textInSearch: false,
            }
        },
        computed: {
            blockedCurrType() {
                if (this.currDirection === 'curr_give' && this.content.selectedCurrency.curr_recive.type) {
                    return this.content.selectedCurrency.curr_recive.type;
                }
                
                if (this.currDirection === 'curr_recive' && this.content.selectedCurrency.curr_give.type) {
                    return this.content.selectedCurrency.curr_give.type;
                }
        
                return null;
            },
            isMobile() {
                return this.$store.state.resize.w <= 768;
            }
        },
        methods: {
            typeCurrChange(value) {
                this.of_stage = value;
            },
            checkCurrKeys (currency, searchValue, ...keys) {
                return keys.some(key => 
                    currency[key].toLowerCase()
                    .includes(searchValue.toLowerCase()));
            },
            searchByKeys(array, searchValue, ...keys) {
                const arrayFilter = array.filter(currency => 
                    this.checkCurrKeys(currency, searchValue, ...keys)
                );

                return arrayFilter;
            },
            inputSearchHandler(event) {
                const searchValue = event.target.value;
                this.textInSearch = searchValue ? true : false;

                if (this.currKey == 'only_internal' || !this.currKey) {
                    const searchInternalResult = this.searchByKeys(this.content.currencyData.currListInternal, searchValue, ...this.internalKeys);
                    this.filterCurrListInternal = [...searchInternalResult];
                }

                if (this.currKey == 'only_external' || !this.currKey) {
                    const searchExternalResult = this.searchByKeys(this.content.currencyData.currListExternal, searchValue, ...this.externalKeys);
                    this.filterCurrListExternal = [...searchExternalResult];
                }
            },
            isTypeCurrencyDisabled(giveCurrType, reciveCurrType, blockCurrType) {
                return giveCurrType == blockCurrType || reciveCurrType == blockCurrType;
            },
            addActiveClass(currKey, currDirection, currCode) {
                if (!currKey && this.selectedCurrency[currDirection].code == currCode) {
                    return 'curr-item-selected';
                }

                if (currKey && 
                    (this.selectedCurrency.curr.code == currCode && this.selectedCurrency.curr.typeCurr == this.fieldId || 
                        this.selectedCurrency.external_type.code == currCode && this.selectedCurrency.external_type.typeCurr == this.fieldId || 
                        this.selectedCurrency.external_type_curr.code == currCode && this.selectedCurrency.external_type_curr.typeCurr == this.fieldId)
                ) {
                    return 'curr-item-selected';
                }
            },
            choiseCurr(currCode, currName, currType, currDirection) {
                if (!this.currKey) {
                    if (currDirection === 'curr_give' && this.content.selectedCurrency.curr_recive.type == currType) {
                        return;
                    }
                    if (currDirection === 'curr_recive' && this.content.selectedCurrency.curr_give.type == currType) {
                        return;
                    }
                }

                let currData = null;
                if (currType === 'internal') {
                    currData = this.content.currencyData.currListInternal.find(curr => curr.code === currCode);
                } else {
                    currData = this.content.currencyData.currListExternal.find(curr => curr.code === currCode);
                }

                this.content.updateCurr(currCode, currName, currType, currDirection, currData?.logo);

                this.close();
            },
            removeCurr(currDirection) {
                this.content.clearCurr(currDirection);
                if (currDirection == 'curr_give') {
                    this.content.selectedCurrency.curr_give = {};
                }

                if (currDirection == 'curr_recive') {
                    this.content.selectedCurrency.curr_recive = {};
                }
            },
            clearSearchInput() {
                if (this.$refs.input_search) {
                    this.$refs.input_search.value = "";
                }

                this.textInSearch = false;

                if (this.currKey == 'only_internal' || !this.currKey) {
                    this.filterCurrListInternal = [...this.content.currencyData.currListInternal];
                }
                
                if (this.currKey == 'only_external' || !this.currKey) {
                    this.filterCurrListExternal = [...this.content.currencyData.currListExternal];
                }
            },
            scrollToSelected() {
                const selectedElement = document.querySelector('.curr-item-selected');
                const scrollContainer = document.querySelector('.curr-wrapper');
                
                if (selectedElement && scrollContainer) {
                    const containerRect = scrollContainer.getBoundingClientRect();
                    const cardRect = selectedElement.getBoundingClientRect();

                    const isVisible = (
                        cardRect.top >= containerRect.top &&
                        cardRect.bottom <= containerRect.bottom
                    );

                    if (!isVisible) {
                        // Выполняем прокрутку только если элемент НЕ виден
                        const scrollTop = selectedElement.offsetTop - scrollContainer.offsetTop - (scrollContainer.clientHeight / 2) + (selectedElement.clientHeight / 2);
                        scrollContainer.scrollTo({
                            top: scrollTop,
                            behavior: 'smooth'
                        });
                    }
                }
            },
        },
        mounted() {
            console.log('mounted', this.currKey);
            // если передан ключ - работа только с одним списком, если ключ не передан - с двумя
            if (this.currKey == 'only_internal' || !this.currKey) {
                this.filterCurrListInternal = [...this.content.currencyData.currListInternal];
            }
            
            if (this.currKey == 'only_external' || !this.currKey) {
                this.filterCurrListExternal = [...this.content.currencyData.currListExternal];
            }
        },
        updated() {
            this.$nextTick(() => {
                this.scrollToSelected();
            });
        }
    }
</script>

<style lang="scss" scoped>
    .input-container.disable:focus,
    .input-container.disable:focus-visible {
        border: 1px solid var(--bs-border-color);
        outline: none;
        box-shadow: none;
    }

    .input-search-wrapper {
        display: flex;
        padding-left: 30px;
        width: 100%;
        background-color: white;
        border: 1px solid $primary-stroke;
        border-radius: 8px;
        position: sticky;
        top: 0;
        left: 0;
        padding: 10px 12px;
        height: 40px;
    }
    .input-search {
        width: calc(100% - 20px);
        border: none;
        
        &::placeholder {
            color: $primary-grey !important;
        }
    }
    .input-search:focus,
    .input-search:focus-visible {
        border: none;
        outline: none;
    }

    .curr-container {
        max-height: 60vh;

        @media (max-width: 767px) {
            max-height: auto;
        }
    }
    .curr-wrapper {
        max-height: 45vh;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 8px;

        &::-webkit-scrollbar {
            width: 4px;
            border-radius: 20px;
        }

        &::-webkit-scrollbar-track {
            background: $primary-stroke;
            border-radius: 20px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: $color-menu;
            border-radius: 20px;
            border: 1px solid $primary-grey;
        }

        @media (max-width: 767px) {
            max-height: none;
        }
    }

    .curr-grey-text {
        margin-right: 4px;
    }

    .curr-item {
        border-radius: 12px;
        cursor: pointer;
        width: calc(50% - 8px);
        border: 1px solid $primary-stroke;

        &:hover {
            box-shadow: 0 6px 20px rgba($primary-stroke, 0.4);
        }
        
        @media (max-width: 767px) {
            width: 100%;
        }
    }

    .curr-logo {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .curr-item-selected {
        background-color: $bg-light-blue;
        border: 1px solid $menu-bg;
    }

    .curr-close-btn {
        position: absolute;
        top: 8px;
        right: 8px;
        cursor: pointer;
        background: white;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .disabled-curr-list {
        position: relative;
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.7);
            z-index: 10;
            pointer-events: none;
        }
    }

    .disabled-curr-list .curr-item {
        cursor: not-allowed;
        pointer-events: none;
    }
</style>